
export const CURRENCY = window.holidayFinder.currency
export const LOCALE = window.holidayFinder.locale
export const MARKET = window.holidayFinder.market
export const FETCH_MAIN_FILTER = '/api_no_auth/holiday_finder/deal-search-engine/'
export const FETCH_SECONDARY_FILTER = '/api_no_auth/holiday_finder/deal-filters/'
export const FETCH_OFFERS = '/api_no_auth/holiday_finder/offers/'
export const FETCH_DESTINATIONS = 'https://s3.eu-central-1.amazonaws.com/js.smartair.co.il/test/holidayfinder/autocomplete.json'
export const FETCH_PRICE_GRAPH = '/api_no_auth/holiday_finder/destination-graph/'
export const FETCH_SESSION = '/api_no_auth/holiday_finder/non-cached-offers/search-start/'
export const FETCH_STATIC_HOTELS = '/holidayfinder/static'
export const FETCH_MORE_HOTELS = '/api_no_auth/package_search/sessions'
export const FETCH_AUTOCOMPLETE_CITY = '/ajax/hotels_ac.php?site=67&language=he&sei=40&dynamicPrefix=&hotels_autocomplete_results=google_autocomplete&term='
export const FETCH_FAVORITE_LIST = '/api_no_auth/holiday_finder/offers/'
export const SET_ONBOARDING_EMAIL = '/holidayfinder/emailadd/'
export const FETCH_HOTEL = '/api_no_auth/holiday_finder/hotelsac'
export const SEND_STATISTIC = '/ajax/hf.php'
export const FETCH_USER_PROFILE = '/api_no_auth/holiday_finder/get-user-profile/'
export const FETCH_PING_STATUS = '/api_no_auth/holiday_finder/non-cached-offers/ping-status/'
export const FETCH_USER_PREF = '/api_no_auth/holiday_finder/user/getUserPref'
export const FETCH_USER_ID = '/api_no_auth/holiday_finder/user/getUserId'
export const FETCH_SEARCH_PERFORMED = '/api_no_auth/holiday_finder/user/searchPerformed'
